import { Link, useLocation, useNavigate } from "react-router-dom";

import { useSession } from "../lib/session.js";

/** Week · Month · Settings, and the one solid ink button in the product. */
export function TabBar(): React.JSX.Element {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { canEdit } = useSession();

  const tabs = [
    { to: "/", label: "Week", active: pathname === "/" || pathname.startsWith("/day") },
    { to: "/month", label: "Month", active: pathname.startsWith("/month") },
    { to: "/settings", label: "Settings", active: pathname.startsWith("/settings") },
  ];

  return (
    <nav className="tabbar">
      <div className="tabbar__tabs">
        {tabs.map((tab) => (
          <Link key={tab.to} to={tab.to} className={`tab${tab.active ? " is-active" : ""}`}>
            {tab.label}
          </Link>
        ))}
      </div>

      {/* Offering what the server will refuse is worse than not offering it. */}
      {canEdit && (
        <button type="button" className="button-ink" onClick={() => void navigate("/event/new")}>
          Add event
        </button>
      )}
    </nav>
  );
}
